"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zklink = void 0;
exports.zklink = {
    "addresses": {
        "ProxyAdmin": "0x784eD49c833392922a916f5A4cAD6798734F265d",
        "Multicall2": "0x825267E0fA5CAe92F98540828a54198dcB3Eaeb5",
        "Sumer": "0x553d713e0fB958932b6C40ABAf0b5A1fFae73Da2",
        "CompoundLens": "0x475464Ce3A829Ec9dB1Bed6D411e72087972c472",
        "FeedPriceOracle": "0x3B2Ea1B8A20293e93cb68D7c918f22403700f91A",
        "CompLogic": "0xe93557e3C2f9D6fAbc2e60c0490e927114f89F7C",
        "RedemptionManager": "0xc3A01A290587e099C89dbb9EF2F553A7616D0780",
        "Timelock": "0x6Ad6Cdf89B9b14a6a2B3878d2E6734219A17c680",
        "Comptroller": "0xe6099D924efEf37845867D45E3362731EaF8A98D",
        "sdrETH": "0x54Dfae480e33dC2BEfd42CAA26A432b11b5a27Bd",
        "ETH": "0x0000000000000000000000000000000000000000",
        "CErc20": "0xFBb5806aa3C4a0E4F63C5dD6f698e8F388ad5d72",
        "suErc20": "0xa6e425A652e1aB60767650Dee63c865eCc308e26",
        "JumpRate#1": "0x05505FEA6036C191B1195D95A05CE5E5c9d83299",
        "JumpRate#2": "0x046eCC1452094f6f22Ff98550564c15DF859112c",
        "ZeroRate": "0xa10d3c9Ff2EAAf65dA5B94bf039541991dff2865",
        "sdrUSDC": "0x22203549A2Fe6740A3D85f8ed2cdfDE16464B68B",
        "USDC": "0x1a1A3b2ff016332e866787B311fcB63928464509",
        "sdrUSDT": "0x45f832bd90b50A97f494A5578ea038CaD03C2b3b",
        "USDT": "0x2F8A25ac62179B31D62D7F80884AE57464699059",
        "sdrWBTC": "0x450665dA7c7b72302Ac6fB6b1B20de7bCF38F7c1",
        "WBTC": "0xDa4AaEd3A53962c83B35697Cd138cc6df43aF71f",
        "sdrMBTC": "0x2440414bc0Bf6f7E76CB2f2C5051EdC4a940d441",
        "MBTC": "0x85D431A3a56FDf2d2970635fF627f386b4ae49CC",
        "sdrSolvBTC.m": "0x22c3E783AC857E205523b59EFC4739949f93EE81",
        "SolvBTC.m": "0xbEAf16cFD8eFe0FC97C2a07E349B9411F5dC272C",
        "sdrpufETH": "0xE143694271a0b34ea6C7928d9B66d31f60B2BfeD",
        "pufETH": "0x1B49eCf1A8323Db4abf48b2F5EFaA33F7DdAB3FC",
        "sdrSTONE": "0x03979c0Fba55EA5A8022c79951fEED1c4a3C8324",
        "STONE": "0xDeEC33dc735Baf36b473598C33BCD077A0f32049",
        "sdrManta": "0x67CF127b95A6B957aeDEA5B15626311245167979",
        "Manta": "0xF5d3953a33F78E0412A8988FD77B4920AA968B0b",
        "sdrsuBTC": "0x0Cf1cC35e296931061c263826B5f62DC04ac1C6B",
        "suBTC": "0x8eb01ac3F39f656Dea98fF86D815BD764ccCb7b8"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC",
            "ctokenAddr": "0x22203549A2Fe6740A3D85f8ed2cdfDE16464B68B",
            "underlySym": "USDC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x1a1A3b2ff016332e866787B311fcB63928464509",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDT",
            "ctokenAddr": "0x45f832bd90b50A97f494A5578ea038CaD03C2b3b",
            "underlySym": "USDT",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x2F8A25ac62179B31D62D7F80884AE57464699059",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrWBTC",
            "ctokenAddr": "0x450665dA7c7b72302Ac6fB6b1B20de7bCF38F7c1",
            "underlySym": "WBTC",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xDa4AaEd3A53962c83B35697Cd138cc6df43aF71f",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrSolvBTC.m",
            "ctokenAddr": "0x22c3E783AC857E205523b59EFC4739949f93EE81",
            "underlySym": "SolvBTC.m",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xbEAf16cFD8eFe0FC97C2a07E349B9411F5dC272C",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrpufETH",
            "ctokenAddr": "0xE143694271a0b34ea6C7928d9B66d31f60B2BfeD",
            "underlySym": "pufETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x1B49eCf1A8323Db4abf48b2F5EFaA33F7DdAB3FC",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrsuBTC",
            "ctokenAddr": "0x0Cf1cC35e296931061c263826B5f62DC04ac1C6B",
            "underlySym": "suBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": true,
            "underlyAddr": "0x8eb01ac3F39f656Dea98fF86D815BD764ccCb7b8",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrETH",
            "ctokenAddr": "0x54Dfae480e33dC2BEfd42CAA26A432b11b5a27Bd",
            "underlySym": "ETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": true,
            "permitEnabled": false,
            "underlyAddr": "0x0000000000000000000000000000000000000000"
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#1",
            "contract": "JumpRateModelV2",
            "address": "0x05505FEA6036C191B1195D95A05CE5E5c9d83299",
            "tokens": [
                "ETH",
                "USDC",
                "USDT",
                "WBTC",
                "ETH"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.1",
            "jumpMultiplierPerYear": "3",
            "kink": "0.65"
        },
        {
            "name": "JumpRate#2",
            "contract": "JumpRateModelV2",
            "address": "0x046eCC1452094f6f22Ff98550564c15DF859112c",
            "tokens": [
                "SolvBTC.m",
                "pufETH"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.01",
            "jumpMultiplierPerYear": "3",
            "kink": "0.45"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0xa10d3c9Ff2EAAf65dA5B94bf039541991dff2865",
            "tokens": [
                "suBTC"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=zklink.js.map